export default {
  name: 'HomeRecommendations',
  components: {},
  props: {
    data: {
      type: Array,
      required: true
    }
  },

  data() {
    return {};
  },

  created() {},
  mounted() {},
  computed: {},
  methods: {}
};
